import flatpickr from 'flatpickr';
import rangePlugin from 'flatpickr/dist/esm/plugins/rangePlugin';
import { Russian } from 'flatpickr/dist/esm/l10n/ru';

document.addEventListener("DOMContentLoaded", async function () {
    let bookedDates = [];
    async function fetchBookedDates() {
        try {
            if (typeof bookDates !== 'undefined' && bookDates.length > 0) {
                bookedDates = bookDates.flatMap(event => {
                    let startDate = new Date(event.start_date);
                    let endDate = new Date(event.end_date);
                    let dateArray = [];

                    if (event.start_date === event.end_date) {
                        dateArray.push(new Date(startDate));
                    } else {
                        while (startDate < endDate) {
                            dateArray.push(new Date(startDate));
                            startDate.setDate(startDate.getDate() + 1);
                        }
                    }
                    
                    return dateArray;
                }).map(date => date.toISOString().split('T')[0]);
            }

            updateCalendars();
        } catch (error) {
            console.error("Ошибка при загрузке заблокированных дат:", error);
        }

    }
    flatpickr.localize(Russian);
    function initCalendar(selector, months = 2, linkedSelector) {
        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 4, 0);

        return flatpickr(selector, {
            inline: !linkedSelector,
            dateFormat: "Y-m-d",
            disable: bookedDates,
            clickOpens: false, //TODO убрать ограничения; Запрещаем открытие календаря кликом
            allowInput: false, //TODO убрать ограничения; Запрещаем ввод даты вручную
            minDate: "today",
            maxDate: maxDate,
            showMonths: months,
            plugins: linkedSelector ? [new rangePlugin({ input: linkedSelector })] : [],
            disableDaysInNextAndPrevMonths: true,
            onDayCreate: highlightBookedDays
        });
    }

    function highlightBookedDays(dObj, dStr, fp, dayElem) {
        let localDate = formatDate(dayElem.dateObj);
        if (bookedDates.includes(localDate)) {
            dayElem.classList.add("booked");
            dayElem.setAttribute("title", "Забронировано");
        }
    }

    function formatDate(date) {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0];
    }

    function updateBookingInputs(start, end) {
        ["desctop", "mobile"].forEach(type => {
            document.getElementById(`${type}-arrival-date`).value = start;
            document.getElementById(`${type}-departure-date`).value = end;
            updateNightCount(type);
        });
    }

    // Инициализация календарей
    let datePicker = initCalendar(".date-range", getShowMonths());

    function updateCalendars() {
        datePicker.set("disable", bookedDates);
    }

    await fetchBookedDates(); // Загружаем заблокированные даты

    // Обновляем календарь при изменении размера экрана
    window.addEventListener('resize', () => {
        datePicker.destroy(); // Удаляем календарь перед пересозданием


        // Переинициализируем календари
        const newMonths = getShowMonths();
        datePicker = initCalendar(".date-range", newMonths);


        updateCalendars();
    });

    function getShowMonths() {
        return window.innerWidth <= 768 ? 1 : 2;
    }

});
